import { createSelector } from 'reselect';
import { initialState } from '../store/models/auth';

const authSelector = state => state.auth || initialState;

const makeSelectIdTkn = () => createSelector(authSelector, globalState => globalState.idToken);

const makeSelectLoading = () => createSelector(authSelector, globalState => globalState.loading);

const makeSelectAccessTkn = () =>
  createSelector(authSelector, globalState => globalState.accessToken);

const makeSelectProfile = () => createSelector(authSelector, globalState => globalState.profile);

const makeSelectSubscriptions = () =>
  createSelector(authSelector, globalState => globalState.subscriptions);

const makeSelectError = () => createSelector(authSelector, globalState => globalState.error);

const makeSelectUserID = () =>
  createSelector(authSelector, globalState =>
    globalState.profile ? globalState.profile.sub : false
  );

const makeSelectUser = () => createSelector(authSelector, globalState => globalState.userinfo);

const makeSelectTab = () => createSelector(authSelector, globalState => globalState.tab);

const selectAccess = () =>
  createSelector(authSelector, globalState => {
    const { profile } = globalState;
    if (!profile) return {};
    const appMeta = profile[process.env.REACT_APP_APP_METADATA_KEY];
    if (!appMeta) return {};
    return appMeta.episourceAccess || {};
  });

const selectAuthClients = () =>
  createSelector(authSelector, globalState => {
    const { profile } = globalState;
    if (!profile) return {};
    const appMeta = profile[process.env.REACT_APP_APP_METADATA_KEY];
    if (!appMeta) return {};
    return appMeta.clientIds || {};
  });

export {
  authSelector,
  makeSelectIdTkn,
  makeSelectAccessTkn,
  makeSelectProfile,
  makeSelectSubscriptions,
  makeSelectLoading,
  makeSelectError,
  makeSelectUserID,
  makeSelectUser,
  makeSelectTab,
  selectAccess,
  selectAuthClients,
};
